import { ValueProvider } from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig } from '@angular/material/dialog';

interface TypedValueProvider<T> extends ValueProvider {
  useValue: T;
}

const DIALOG_DEFAULT_OPTIONS_PROVIDER: TypedValueProvider<MatDialogConfig> = {
  provide: MAT_DIALOG_DEFAULT_OPTIONS,
  useValue: {
    disableClose: true,
    autoFocus: true,
  },
};

export const MATERIAL_PROVIDERS = [DIALOG_DEFAULT_OPTIONS_PROVIDER];
